import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const agregarMotivoDerivacion = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.MOTIVO_DERIVACION.ADD}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default agregarMotivoDerivacion;